import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import A1StatsComponent from '../../components/a1stats/A1StatsComponent';

const headerTags =
{
    title: 'Estatisticas',
    meta: {
        description: 'Estatisticas',
        robots: 'noindex, nofollow',
    },
};

export default function A1Stats() {
    return (
        <div className="pageWrapper">
            <HeaderTags title={headerTags.title} meta={headerTags.meta} />
            <A1StatsComponent />
        </div>
    );
}
